import { Button, Tooltip } from 'antd';
import { StarFilled, StarOutlined } from '@ant-design/icons';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { OwnerType } from '@never2busy/shared';
import { favoritesApi } from '../../api/endpoints/favorites';

interface FavoriteToggleProps {
  ownerType: OwnerType;
  ownerId: number;
  size?: 'small' | 'middle' | 'large';
  /** Si solo quieres mostrar el icono sin afectar el flujo principal. */
  stopPropagation?: boolean;
}

export function FavoriteToggle({
  ownerType,
  ownerId,
  size = 'middle',
  stopPropagation = false,
}: FavoriteToggleProps): JSX.Element {
  const queryClient = useQueryClient();

  const favs = useQuery({
    queryKey: ['favorites', ownerType],
    queryFn: () => favoritesApi.list(ownerType),
    staleTime: 30_000,
  });

  const isFav = favs.data?.some((f) => f.ownerId === ownerId) ?? false;

  const mutation = useMutation({
    mutationFn: () => favoritesApi.toggle(ownerType, ownerId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['favorites'] });
      // si la lista de cuentas usa favoritesOnly filtro, refrescar
      void queryClient.invalidateQueries({ queryKey: ['accounts'] });
      void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });

  return (
    <Tooltip title={isFav ? 'Quitar de favoritos' : 'Marcar como favorito'}>
      <Button
        type="text"
        size={size}
        icon={
          isFav ? (
            <StarFilled style={{ color: '#faad14' }} />
          ) : (
            <StarOutlined style={{ color: '#bfbfbf' }} />
          )
        }
        loading={mutation.isPending}
        onClick={(e) => {
          if (stopPropagation) e.stopPropagation();
          mutation.mutate();
        }}
      />
    </Tooltip>
  );
}
